import { setupAxios } from '../app/modules/auth'
import { API_BASE_URL } from '../utils/contants'

// form save api integration
export async function addSalaryStructure(InputField: {
    salaryStructureName:string;
    basic: boolean;
    HRA: boolean;
    DA:boolean;
    education: boolean;
    LTA: boolean;
    specialAllowance: boolean;
    variable: boolean;
    telephoneAndInternetReimbursement: boolean;
    carAndDriverReimbursement: boolean;
    mealCoupon: boolean;
    booksAndPeriodicals: boolean;   
    PF: boolean;
    PT: boolean;
    ESIC: boolean;
    LWF: boolean;
}) {
    const { token, tenantId } = setupAxios()

    const res = await fetch(API_BASE_URL + `/salarystructure`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-tenant-Id': `${tenantId}`
        },
        body: JSON.stringify({
            basic: InputField.basic,
            HRA: InputField.HRA,
            DA:InputField.DA,
            education: InputField.education,
            LTA: InputField.LTA,
            specialAllowance: InputField.specialAllowance,
            variable: InputField.variable,
            telephoneAndInternetReimbursement: InputField.telephoneAndInternetReimbursement,
            carAndDriverReimbursement: InputField.carAndDriverReimbursement,
            mealCoupon: InputField.mealCoupon,
            booksAndPeriodicals: InputField.booksAndPeriodicals,           
            PF: InputField.PF,
            PT: InputField.PT,
            ESIC: InputField.ESIC,
            LWF: InputField.LWF, 
            salaryStructureName:InputField.salaryStructureName,         
        }),
    })
    return await res.json()
}

//edit by id
export async function updateSalaryStructureById(
    InputField: {
        salaryStructureName:string;
        basic: boolean;
        HRA: boolean;
        DA:boolean,
        education: boolean;
        LTA: boolean;
        specialAllowance: boolean;
        variable: boolean;
        telephoneAndInternetReimbursement: boolean;
        carAndDriverReimbursement: boolean;
        mealCoupon: boolean;
        booksAndPeriodicals: boolean;
        PF: boolean;
        PT: boolean;
        ESIC: boolean;
        LWF: boolean;
    },
    id: string
) {
    const { token, tenantId } = setupAxios()
    const res = await fetch(API_BASE_URL + `/salarystructure/${id}`, {
        method: 'PATCH',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-tenant-Id': `${tenantId}`
        },
        body: JSON.stringify({
            basic: InputField.basic,
            HRA: InputField.HRA,
            DA:InputField.DA,
            education: InputField.education,
            LTA: InputField.LTA,
            specialAllowance: InputField.specialAllowance,
            variable: InputField.variable,
            telephoneAndInternetReimbursement: InputField.telephoneAndInternetReimbursement,
            carAndDriverReimbursement: InputField.carAndDriverReimbursement,
            mealCoupon: InputField.mealCoupon,
            booksAndPeriodicals: InputField.booksAndPeriodicals,           
            PF: InputField.PF,
            PT: InputField.PT,
            ESIC: InputField.ESIC,
            LWF: InputField.LWF,
            salaryStructureName:InputField.salaryStructureName,            
        }),
    })
    return await res.json()
}

//   get SalaryStructure

export async function getSalaryStructures() {
    const { token, tenantId } = setupAxios()
    const res = await fetch(API_BASE_URL + `/salarystructure`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-tenant-Id': `${tenantId}`
        },
    })
    return await res.json()
}

//   delete salarystructure

export async function deleteSalaryStructures(id: string) {
    const { token, tenantId } = setupAxios()
    const res = await fetch(API_BASE_URL + `/salarystructure/${id}`, {
        method: 'DELETE',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-tenant-Id': `${tenantId}`
        },
    })
    return await res.json()
}

//getSalaryStructurebyid

export async function getSalaryStructuresById(userId: string | undefined) {
    const { token, tenantId } = setupAxios()
    const res = await fetch(API_BASE_URL + `/salarystructure/${userId}`, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
            'X-tenant-Id': `${tenantId}`
        },        
    })
    if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }
    return await res.json()
}
